import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import styled from "styled-components";
import { InfoBox } from "@bindeleddet/core/components";
import { Article } from "@bindeleddet/core/types";
import axios from "axios";
import fallback from "assets/images/fallbackImg.png";

interface Props {
  currentArticleId?: number;
}

// @bindeleddet/core's InfoBox hardcodes an asymmetric inline padding
// (10px top, 32px bottom) on its button, pushing the label upward.
// Needs a core-side fix; overriding here (inline style beats plain CSS, hence
// !important) for now.
const StyledRow = styled(Row)`
  .ant-btn {
    padding: 10px 30px !important;
  }
`;

const ArticleCards: React.FC<Props> = ({ currentArticleId }) => {
  const [articles, setArticles] = useState<Article[]>([]);

  useEffect(() => {
    axios.get<Article[]>("/website-contents/articles/").then(response => {
      setArticles(response.data?.filter(article => article.show_on_frontpage));
    });
  }, [currentArticleId]);

  if (!articles) return null;
  return (
    <>
      <StyledRow justify="center" style={{ width: "100vw", margin: 0 }} gutter={[48, 48]}>
        {articles
          .filter(article => article.id !== currentArticleId)
          .slice(0, 3)
          .map(article => (
            <Col key={article.id}>
              <InfoBox
                imageLink={article.big_image ?? fallback} // TODO show correct image!
                imageAlt=""
                title={article.title}
                text={`${article.content.slice(0, 100)}...`}
                buttonText="Les mer"
                buttonUrlLink={`/articles/${article.id}`}
                downloadable={false}
              />
            </Col>
          ))}
      </StyledRow>
    </>
  );
};

export default ArticleCards;
